import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

/**
 * Batch 8, Sign-up modal subtext
 */
export const FE_BATCH_9_SIGN_UP_MODAL_SUBTEXT_250417 = experiment({
  name: "FE_BATCH_9_SIGN_UP_MODAL_SUBTEXT_250417",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-06-10",
  defaultValue: IFourVariantXP.Bucket.CONTROL,
  productArea: "LOGGED_OUT_RETAILERS",
});
